import { render, staticRenderFns } from "./CreateAssetPage.vue?vue&type=template&id=b6cd8e14"
import script from "./CreateAssetPage.vue?vue&type=script&lang=js"
export * from "./CreateAssetPage.vue?vue&type=script&lang=js"
import style0 from "./CreateAssetPage.vue?vue&type=style&index=0&id=b6cd8e14&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports